import * as React from "react";
import {Trans, useTranslation} from "@unibuddy/intl";
import styled from "styled-components";
import {Box} from "@unibuddy/patron";

import {ThemedLink} from "../../../../components/ThemedLink/ThemedLink";
import {useUniversity} from "../../UniversityProvider/UniversityProvider";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_UPDATED_INSTITUTION_POLICY_SHORT} from "../../../../translations/privacy-text";

const StyledBox = styled(Box)`
    text-align: center;
    font-size: 0.875rem;
`;

export const InstitutionPolicyTextShort: React.FC = () => {
    const {t} = useTranslation(IntlNamespaces.PRIVACY_TEXT);
    const {name: universityName, privacyPolicyUrl} = useUniversity();

    return (
        <StyledBox display="block">
            <Trans t={t} i18nKey={INTL_UPDATED_INSTITUTION_POLICY_SHORT.key}>
                {"By continuing, you agree to the "}
                {{universityName}}{" "}
                <ThemedLink external to={privacyPolicyUrl} target="_blank">
                    Privacy Policy
                </ThemedLink>
            </Trans>
        </StyledBox>
    );
};
